import type { BishopDataJSON, MiniBossDataJSON, TOWW_DataJSON, WitnessDataJSON,  } from "../../../../data/types";

import bishopDataJSON from "./bishop-data.json";
import towwDataJSON from "./toww-data.json";

import miniBossDataJSON from "./mini-boss-data.json";
import witnessDataJSON from "./witness-data.json";

const bishopData: BishopDataJSON = bishopDataJSON;
const towwData: TOWW_DataJSON = towwDataJSON;

const miniBossData: MiniBossDataJSON = miniBossDataJSON;
const witnessData: WitnessDataJSON = witnessDataJSON;

export { bishopData, towwData, miniBossData, witnessData };